import { render, staticRenderFns } from "./PartnerRegisterIndex.vue?vue&type=template&id=4960beb7&scoped=true&"
import script from "./PartnerRegisterIndex.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerRegisterIndex.vue?vue&type=style&index=0&id=4960beb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960beb7",
  null
  
)

export default component.exports